import { css } from '@emotion/css';

import { FilterProps } from '@/components/Filter/types';

const GroupSearchMenuWidth = css`
  width: 45.6rem;
  .filter-items {
    height: 32rem;
    min-height: 32rem;
  }
`;

export const MENU_LIST_OVERRIDES: FilterProps['overrides'] = {
  className: GroupSearchMenuWidth,
};
